import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, isRef as _isRef, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, vModelText as _vModelText, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, vModelCheckbox as _vModelCheckbox, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-118918fb"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "main" }
const _hoisted_2 = { id: "main-body" }
const _hoisted_3 = { class: "body-head" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, null, -1))
const _hoisted_5 = {
  key: 0,
  class: "select-material child-class"
}
const _hoisted_6 = ["value"]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "select-highlight" }, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "select-bar" }, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "select-label" }, "クラス選択", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spacer" }, null, -1))
const _hoisted_11 = { class: "board" }
const _hoisted_12 = { class: "board-head" }
const _hoisted_13 = {
  key: 0,
  class: "deadline"
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spacer" }, null, -1))
const _hoisted_15 = { class: "board-buttons" }
const _hoisted_16 = { class: "daily-report" }
const _hoisted_17 = { class: "search-results report" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "天気"),
    /*#__PURE__*/_createElementVNode("th", null, "室温（朝）"),
    /*#__PURE__*/_createElementVNode("th", null, "室温（夕）"),
    /*#__PURE__*/_createElementVNode("th", null, "湿度"),
    /*#__PURE__*/_createElementVNode("th", null, "暑さ指数")
  ])
], -1))
const _hoisted_19 = ["href"]
const _hoisted_20 = ["href"]
const _hoisted_21 = { class: "search-results report" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { colspan: "4" }, "発令警報")
  ]),
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "警報名"),
    /*#__PURE__*/_createElementVNode("th", null, "発報日時"),
    /*#__PURE__*/_createElementVNode("th", null, "解消日時"),
    /*#__PURE__*/_createElementVNode("th", null, "アクション")
  ])
], -1))
const _hoisted_23 = { class: "time" }
const _hoisted_24 = { class: "time" }
const _hoisted_25 = { class: "action" }
const _hoisted_26 = ["onClick"]
const _hoisted_27 = ["onUpdate:modelValue"]
const _hoisted_28 = ["href"]
const _hoisted_29 = { class: "time" }
const _hoisted_30 = ["onUpdate:modelValue"]
const _hoisted_31 = { class: "time" }
const _hoisted_32 = ["onUpdate:modelValue"]
const _hoisted_33 = { class: "action" }
const _hoisted_34 = ["disabled", "onClick"]
const _hoisted_35 = ["onClick"]
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_39 = { class: "actions" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spacer" }, null, -1))
const _hoisted_41 = {
  key: 0,
  class: "search-results report"
}
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { colspan: "4" }, "利用児童"),
    /*#__PURE__*/_createElementVNode("th", { colspan: "4" }, "勤務従事者"),
    /*#__PURE__*/_createElementVNode("th", { rowspan: "2" }, "当日リーダー")
  ]),
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "予定人数（昼）"),
    /*#__PURE__*/_createElementVNode("th", null, "在園人数（昼）"),
    /*#__PURE__*/_createElementVNode("th", null, "予定人数（夜）"),
    /*#__PURE__*/_createElementVNode("th", null, "在園人数（夜）"),
    /*#__PURE__*/_createElementVNode("th", null, "予定人数（昼）"),
    /*#__PURE__*/_createElementVNode("th", null, "勤務人数（昼）"),
    /*#__PURE__*/_createElementVNode("th", null, "予定人数（夜）"),
    /*#__PURE__*/_createElementVNode("th", null, "勤務人数（夜）")
  ])
], -1))
const _hoisted_43 = { class: "search-results report" }
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { colspan: "4" }, "注意事項・行事予定")
  ]),
  /*#__PURE__*/_createElementVNode("tr", { class: "event-header" }, [
    /*#__PURE__*/_createElementVNode("th", null, "項目"),
    /*#__PURE__*/_createElementVNode("th", null, "日付"),
    /*#__PURE__*/_createElementVNode("th", null, "内容"),
    /*#__PURE__*/_createElementVNode("th", null, "アクション")
  ])
], -1))
const _hoisted_45 = ["onClick"]
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { colspan: "3" }, null, -1))
const _hoisted_47 = { id: "hand-over" }
const _hoisted_48 = { class: "heading links" }
const _hoisted_49 = { class: "i-links" }
const _hoisted_50 = { class: "search-results" }
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "分類", -1))
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "child-col" }, "対象児童", -1))
const _hoisted_53 = { key: 0 }
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "staff-col" }, "対象従事者", -1))
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "項目", -1))
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "内容", -1))
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "記述日時", -1))
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "記述者", -1))
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "アクション", -1))
const _hoisted_60 = { key: 0 }
const _hoisted_61 = { class: "buttons" }
const _hoisted_62 = ["onClick"]
const _hoisted_63 = { key: 0 }
const _hoisted_64 = { class: "select_styled" }
const _hoisted_65 = ["onUpdate:modelValue"]
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  value: "-1",
  selected: ""
}, "なし", -1))
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "0" }, "全員", -1))
const _hoisted_68 = ["value"]
const _hoisted_69 = { class: "select_styled" }
const _hoisted_70 = ["onUpdate:modelValue"]
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  value: "0",
  selected: "",
  disabled: ""
}, "選択して下さい", -1))
const _hoisted_72 = ["value"]
const _hoisted_73 = { class: "buttons" }
const _hoisted_74 = ["onClick", "disabled"]
const _hoisted_75 = ["onClick"]
const _hoisted_76 = { class: "anchor-nav" }
const _hoisted_77 = {
  key: 0,
  class: "btn-small has-icon down",
  href: "#children-status"
}
const _hoisted_78 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  class: "btn-small has-icon down",
  href: "#employee-status"
}, "従事者の勤務状況", -1))
const _hoisted_79 = {
  key: 1,
  class: "btn-small has-icon down",
  href: "#condition"
}
const _hoisted_80 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  class: "btn-small has-icon down",
  href: "#hand-over"
}, "申し送り事項（報連相）", -1))
const _hoisted_81 = {
  key: 2,
  class: "btn-small has-icon down",
  href: "#allergy"
}
const _hoisted_82 = {
  key: 0,
  id: "condition"
}
const _hoisted_83 = { class: "heading links" }
const _hoisted_84 = { class: "i-links" }
const _hoisted_85 = { class: "search-results report" }
const _hoisted_86 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "児童名", -1))
const _hoisted_87 = { key: 0 }
const _hoisted_88 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "時刻", -1))
const _hoisted_89 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "分類", -1))
const _hoisted_90 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "状態", -1))
const _hoisted_91 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "内容", -1))
const _hoisted_92 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "対応者", -1))
const _hoisted_93 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "備考", -1))
const _hoisted_94 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "アクション", -1))
const _hoisted_95 = { key: 0 }
const _hoisted_96 = { class: "buttons" }
const _hoisted_97 = ["onClick"]
const _hoisted_98 = { class: "select_styled" }
const _hoisted_99 = ["onUpdate:modelValue"]
const _hoisted_100 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  value: "0",
  disabled: "",
  selected: "",
  class: "none"
}, "選択してください", -1))
const _hoisted_101 = ["value"]
const _hoisted_102 = { key: 0 }
const _hoisted_103 = ["onUpdate:modelValue"]
const _hoisted_104 = { class: "select_styled" }
const _hoisted_105 = ["onUpdate:modelValue"]
const _hoisted_106 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  value: "0",
  disabled: "",
  selected: "",
  class: "none"
}, "選択してください", -1))
const _hoisted_107 = ["value"]
const _hoisted_108 = { class: "buttons" }
const _hoisted_109 = ["onClick", "disabled"]
const _hoisted_110 = ["onClick"]
const _hoisted_111 = {
  key: 1,
  id: "children-status"
}
const _hoisted_112 = { class: "heading links" }
const _hoisted_113 = { class: "i-links" }
const _hoisted_114 = { class: "search-results report" }
const _hoisted_115 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { rowspan: "2" }, "名前", -1))
const _hoisted_116 = {
  key: 0,
  rowspan: "2"
}
const _hoisted_117 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { colspan: "2" }, "予定", -1))
const _hoisted_118 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { colspan: "4" }, "在園状況", -1))
const _hoisted_119 = {
  class: "memo",
  rowspan: "2"
}
const _hoisted_120 = {
  class: "memo-status",
  rowspan: "2"
}
const _hoisted_121 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { rowspan: "2" }, "打刻忘れ操作", -1))
const _hoisted_122 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("th", null, "時間"),
  /*#__PURE__*/_createElementVNode("th", { class: "meal" }, "給食"),
  /*#__PURE__*/_createElementVNode("th", null, "時刻"),
  /*#__PURE__*/_createElementVNode("th", null, "状況/[タイトル]"),
  /*#__PURE__*/_createElementVNode("th", null, "体温"),
  /*#__PURE__*/_createElementVNode("th", { class: "meal" }, "給食")
], -1))
const _hoisted_123 = { key: 0 }
const _hoisted_124 = { class: "child meal" }
const _hoisted_125 = ["disabled", "onClick"]
const _hoisted_126 = { class: "child meal" }
const _hoisted_127 = ["disabled", "onClick"]
const _hoisted_128 = { class: "memo-act" }
const _hoisted_129 = ["onUpdate:modelValue", "maxlength"]
const _hoisted_130 = ["onClick"]
const _hoisted_131 = { class: "label" }
const _hoisted_132 = { class: "inout-act" }
const _hoisted_133 = ["onUpdate:modelValue", "maxlength"]
const _hoisted_134 = ["onClick"]
const _hoisted_135 = ["onClick"]
const _hoisted_136 = ["onClick"]
const _hoisted_137 = {
  key: 2,
  id: "allergy"
}
const _hoisted_138 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "heading" }, "アレルギー/未食 管理", -1))
const _hoisted_139 = { class: "search-results" }
const _hoisted_140 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "児童名", -1))
const _hoisted_141 = { key: 0 }
const _hoisted_142 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "区分", -1))
const _hoisted_143 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "品目", -1))
const _hoisted_144 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "食事", -1))
const _hoisted_145 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "含有の有無", -1))
const _hoisted_146 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "確認", -1))
const _hoisted_147 = { key: 0 }
const _hoisted_148 = ["onUpdate:modelValue", "onChange"]
const _hoisted_149 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "checkbox-parts" }, null, -1))
const _hoisted_150 = { id: "employee-status" }
const _hoisted_151 = { class: "heading links" }
const _hoisted_152 = { class: "i-links" }
const _hoisted_153 = { class: "search-results report" }
const _hoisted_154 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { rowspan: "2" }, "名前", -1))
const _hoisted_155 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { rowspan: "2" }, "予定", -1))
const _hoisted_156 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { colspan: "3" }, "勤務状況", -1))
const _hoisted_157 = {
  class: "memo",
  rowspan: "2"
}
const _hoisted_158 = {
  class: "memo-status",
  rowspan: "2"
}
const _hoisted_159 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("th", null, "時刻"),
  /*#__PURE__*/_createElementVNode("th", null, "状況/[タイトル]"),
  /*#__PURE__*/_createElementVNode("th", null, "体温")
], -1))
const _hoisted_160 = { class: "memo-act" }
const _hoisted_161 = ["onUpdate:modelValue", "maxlength"]
const _hoisted_162 = ["onClick"]
const _hoisted_163 = { class: "label" }
const _hoisted_164 = { class: "inout-act" }
const _hoisted_165 = ["onUpdate:modelValue", "maxlength"]
const _hoisted_166 = ["onClick"]
const _hoisted_167 = {
  key: 0,
  class: "maint-btns"
}
const _hoisted_168 = {
  key: 1,
  class: "board"
}
const _hoisted_169 = {
  key: 0,
  class: "s-modal"
}
const _hoisted_170 = { class: "modal-frame event-dialog" }
const _hoisted_171 = { class: "edit-event" }
const _hoisted_172 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dt", null, "対象日", -1))
const _hoisted_173 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "from-to" }, "～", -1))
const _hoisted_174 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dt", null, "分類項目", -1))
const _hoisted_175 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dt", null, "表示内容", -1))
const _hoisted_176 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dt", null, "掲載日", -1))
const _hoisted_177 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "from-to" }, "～", -1))
const _hoisted_178 = { class: "board-buttons -under" }
const _hoisted_179 = ["disabled"]

import { ref, computed, watch } from 'vue';
import { useStore } from 'vuex';
import { loadBasic, getSelectableBaseOpts, getBaseRange } from '@/utility/BaseOpts';
import {
  HomeData,
  initHomeData,
  loadChildInOut,
  loadStaffInOut,
  loadChildHealth,
  isValidChildCondtion,
  toValidClassStr,
  isValidInform,
  loadBase,
  loadDEvents,
  indexToTimeN,
  loadInform,
  loadAllergy,
  toStatusMsgChild,
  toStatusMsgStaff,
  toTemperText,
  openAddEventDialog,
  openEditEventDialog,
  okEventDialog,
  isValidEventDialog,
  cancelEventDialog,
  toDInformName,
  isValidCHealthSituation,
  isValidCHealthAction,
  isValidCHealthContact,
  isValidDInformTitleName,
  isValidDInformItemName,
  isValidDInformContents,
  weatherList,
  indoorTemps,
  humidities,
  wbgts,
  isEditableScheduleMeal,
  isEditableResultMeal,
  toggleScheduleMeal,
  incResultMeal,
  isOfficeBase,
  onMaintMStaff,
  onMaintMChild,
  onMaintC2Schedule,
  onMaintC3Result,
  onMaintMStaffDailyMemo,
  isEnabledRepunch,
  repunchInitDate,
  lastPunchDate,
  addC4Punch,
  getChildNameOpts,
  addChildCondition,
  addInform,
  addAlarm,
  save,
  saveScheduleMeal,
  saveResultMeal,
  saveAndLoadChildHealth,
  saveAndLoadInform,
  saveAndLoadAllergy,
  saveMemoChild,
  saveMemoStaff,
  saveMemoStatusChild,
  saveMemoStatusStaff,
  deleteAndLoadChildCondtion,
  deleteAndLoadInform,
  deleteAlarm,
  toMemoTitle,
  toCategoryText,
  toBackStatusId,
  toRealClassName,
} from '@/utility/Home';
import { RepunchCtrl, initRepunchCtrl, openRepunchDialog, initRepunchTitles } from '@/utility/RepunchDialog';
import { toDateKey, toMMdd, toDate, addDate } from '@/utility/date';
import { validClass, toValidClassNum, isEmptyOrFloat, isEmptyOrIntger } from '@/utility/valid';
import { confirm, alert } from '@/utility/messages';
import { onBeforeRouteLeave } from 'vue-router';
import {
  initPulldownList,
  PidCHealthCase,
  PidCHealthSituation,
  PidCHealthAction,
  PidCHealthContact,
  PidDInformTitle,
  PidDInformItem,
  PidDInformContents,
} from '@/utility/PulldownList';
import { getLoginUser } from '@/utility/login';
import { masterMsg } from '@/utility/browsing-authority';
import { getStoreBCode, setStoreBCode, getStoreTargetDate, setStoreTargetDate } from '@/utility/Store';
import { checkMaintMStaffBase } from '@/utility/maint';
import { Punch, ChildTitleStatus, StaffTitleStatus } from '@/utility/consts/DbTables';
import { classAll } from '@/utility/consts/ComProps';
import { contentLength, statusLength } from '@/utility/consts/DbTables';
import { StaffRoll } from '@/utility/consts/DbTables';
import { onMounted, onUnmounted } from 'vue';
import { EDeadline, getDeadlineDay } from '@/utility/deadline-setting';
import AdminHeader from '@/components/AdminHeader.vue';
import InputSelect from '@/components/InputSelect.vue';
import SelectStaffSearch from '@/components/SelectStaffSearch.vue';
import InputListEdit from '@/components/InputListEdit.vue';
import SelectBase from '@/components/SelectBase.vue';
import SelectDate from '@/components/SelectDate.vue';
import RepunchDialog from '@/components/RepunchDialog.vue';
import SelectBoxNum from '@/components/SelectBoxNum.vue';
import router from '@/router';
import { moveToAdminLoginWhenError } from '@/utility/login';
import { DisplayError } from '@/error/error-ex';


export default /*#__PURE__*/_defineComponent({
  __name: 'HomeView',
  setup(__props) {

const user = getLoginUser();
const store = useStore();

//  日付
const targetDate = computed({
  get: () => getStoreTargetDate(store),
  set: value => setStoreTargetDate(store, value),
});
watch(
  () => targetDate.value,
  (newValue, oldValue) => {
    if (newValue === oldValue) return;
    updateView().then(res => {
      if (res < 0) targetDate.value = oldValue;
    });
  }
);

//  拠点
const bCode = computed({
  get: () => getStoreBCode(store),
  set: value => setStoreBCode(store, value),
});
watch(
  () => bCode.value,
  (newValue, oldValue) => {
    if (newValue === oldValue) return;
    updateView().then(res => {
      if (res < 0) bCode.value = oldValue;
    });
  }
);

//  選択拠点の有効期限
const bRange = computed(() => getBaseRange(home.value.basic, bCode.value));

async function updateView(): Promise<number> {
  if (!bCode.value || getLoginUser() === null) return 0;

  try {
    await loadBasic(home.value.basic, targetDate.value, bCode.value, false);

    await loadBase(home.value, toDateKey(targetDate.value), bCode.value);
    editedMove.value = false;
    await loadDEvents(home.value, toDateKey(targetDate.value), bCode.value);
    await loadChildInOut(home.value, toDateKey(targetDate.value), bCode.value);
    await loadStaffInOut(home.value, toDateKey(targetDate.value), bCode.value);
    await loadChildHealth(home.value, toDateKey(targetDate.value), bCode.value);
    await loadInform(home.value, toDateKey(targetDate.value), bCode.value);
    await loadAllergy(home.value, toDateKey(targetDate.value), bCode.value);
    return 1;
  } catch (err) {
    if (err instanceof DisplayError) await alert(err.message);
    return -1;
  }
}

const home = ref<HomeData>(initHomeData);
const repunchCtrl = ref<RepunchCtrl>(initRepunchCtrl);
const selectableBaseOpts = computed(() => getSelectableBaseOpts(home.value.basic));
const move = computed(() => home.value.movement);
const daily = computed(() => home.value.movement.dDaily);
const dAlarms = computed(() => home.value.movement.dAlarms);
const editedMove = computed({
  get: () => home.value.editedMovement,
  set: value => (home.value.editedMovement = value as boolean),
});

const dEvents = computed(() => home.value.dEvents);
const childNameRec = computed(() => home.value.childNameRec);
const childNameOpts = computed(() => getChildNameOpts(home.value));
const childClassOpts = computed(() => home.value.childClassOpts);
const staffNameRec = computed(() => home.value.staffNameRec); //<  従業者
const staffNameOpts = computed(() => home.value.staffNameOpts); //<  従業者
const classes = computed(() => home.value.classes); //<  従業者
const childInOuts = computed(() => home.value.childInOuts); //<  児童の登降園状況
const staffInOuts = computed(() => home.value.staffInOuts); //<  従事者の出退勤状況
const childConds = computed(() => home.value.cHealthes);
const dInforms = computed(() => home.value.dInforms);
const cAllergys = computed(() => home.value.cAllergyCheck);
const eventDialog = computed(() => home.value.eventDialog);
const eventDialogTargetDateFrom = computed({
  get: () => toDateKey(eventDialog.value.dEvent.targetDateFrom),
  set: value => (eventDialog.value.dEvent.targetDateFrom = toDate(new Date(value))),
});
const eventDialogTargetDateTo = computed({
  get: () => toDateKey(eventDialog.value.dEvent.targetDateTo),
  set: value => (eventDialog.value.dEvent.targetDateTo = toDate(new Date(value))),
});
const eventDialogStartDate = computed({
  get: () => toDateKey(eventDialog.value.dEvent.startDate),
  set: value => (eventDialog.value.dEvent.startDate = toDate(new Date(value))),
});
const eventDialogEndDate = computed({
  get: () => toDateKey(eventDialog.value.dEvent.endDate),
  set: value => (eventDialog.value.dEvent.endDate = toDate(new Date(value))),
});
const indoorTempList = computed(() => indoorTemps());
const humidityList = computed(() => humidities());
const wbgtList = computed(() => wbgts());
const className = computed({
  get: () => home.value.className,
  set: value => (home.value.className = value),
});
const isHasClass = computed(() => home.value.classes.length > 1 || (home.value.classes.length === 1 && home.value.classes[0].length === 0));
const isOffice = computed(() => isOfficeBase(home.value, bCode.value));
const caseList = computed(() => home.value.pulldownLists.find(v => v.pId === PidCHealthCase) ?? initPulldownList(PidCHealthCase));
const situationList = computed(
  () => home.value.pulldownLists.find(v => v.pId === PidCHealthSituation) ?? initPulldownList(PidCHealthSituation)
);
const actionList = computed(() => home.value.pulldownLists.find(v => v.pId === PidCHealthAction) ?? initPulldownList(PidCHealthAction));
const contactList = computed(() => home.value.pulldownLists.find(v => v.pId === PidCHealthContact) ?? initPulldownList(PidCHealthContact));

const informTitleList = computed(() => home.value.pulldownLists.find(v => v.pId === PidDInformTitle) ?? initPulldownList(PidDInformTitle));
const informItemList = computed(() => home.value.pulldownLists.find(v => v.pId === PidDInformItem) ?? initPulldownList(PidDInformItem));
const informContentsList = computed(
  () => home.value.pulldownLists.find(v => v.pId === PidDInformContents) ?? initPulldownList(PidDInformContents)
);

const sssStaffOpts = computed(() => home.value.basic.sssStaffOpts);
const sssBaseOpts = computed(() => home.value.basic.sssBaseOpts);

const childMemoTitleOpts = computed(() => home.value.cmTitleOpts);
const staffMemoTitleOpts = computed(() => home.value.smTitleOpts);

const isMaintDisp = ref(false);

//  締め日
const deadlineSche = computed(() => getDeadlineDay(home.value.basic.deadlines, EDeadline.CSchedule)); //< 児童実績

onBeforeRouteLeave(async (): Promise<boolean> => {
  if (!editedMove.value) return true;
  const res = await confirm('日報が保存されていません。保存せず移動しますか？');
  return res as boolean;
});

async function okRepunch() {
  await addC4Punch(repunchCtrl.value, bCode.value);
  await loadChildInOut(home.value, toDateKey(targetDate.value), bCode.value).catch(error => moveToAdminLoginWhenError(error));
}

// reloadイベント
const handleBeforeUnload = (event: BeforeUnloadEvent) => {
  //event.preventDefault();
  bCode.value = getLoginUser()?.staffMainBaseCode ?? '';
};

onMounted(() => {
  window.addEventListener('beforeunload', handleBeforeUnload);
});

onUnmounted(() => {
  window.removeEventListener('beforeunload', handleBeforeUnload);
});

async function init() {
  if (bCode.value === '') {
    bCode.value = home.value.basic.loginUser.sMainBase; //< UpdateViewにより、多重読み込みが発生
  }

  try {
    await loadBasic(home.value.basic, targetDate.value, bCode.value, false);

    await loadBase(home.value, toDateKey(targetDate.value), bCode.value);
    editedMove.value = false;
    await loadDEvents(home.value, toDateKey(targetDate.value), bCode.value);
    await loadChildInOut(home.value, toDateKey(targetDate.value), bCode.value);
    await loadStaffInOut(home.value, toDateKey(targetDate.value), bCode.value);
    await loadChildHealth(home.value, toDateKey(targetDate.value), bCode.value);
    await loadInform(home.value, toDateKey(targetDate.value), bCode.value);
    await loadAllergy(home.value, toDateKey(targetDate.value), bCode.value);
  } catch (err) {
    if (err instanceof DisplayError) await alert(err.message);
    alert('前の画面に戻ります。').then(() => router.back());
  }
}

init();

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_templete = _resolveComponent("templete")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(AdminHeader, { mode: "home" }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        ((_unref(user)?.browsingAuthority?.motionAndStatic ?? 0) > 0)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createElementVNode("div", _hoisted_3, [
                _hoisted_4,
                _createVNode(SelectBase, {
                  modelValue: _unref(bCode),
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(bCode) ? (bCode).value = $event : null)),
                  "base-opts": _unref(selectableBaseOpts),
                  edited: _unref(editedMove),
                  "data-name": "日報"
                }, null, 8, ["modelValue", "base-opts", "edited"]),
                (_unref(isHasClass))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                      _withDirectives(_createElementVNode("select", {
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(className) ? (className).value = $event : null)),
                        class: "select-text",
                        required: ""
                      }, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(classes), (str) => {
                          return (_openBlock(), _createElementBlock("option", {
                            key: str,
                            value: str
                          }, _toDisplayString(str), 9, _hoisted_6))
                        }), 128))
                      ], 512), [
                        [_vModelSelect, _unref(className)]
                      ]),
                      _hoisted_7,
                      _hoisted_8,
                      _hoisted_9
                    ]))
                  : _createCommentVNode("", true),
                _hoisted_10
              ]),
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                  _createVNode(SelectDate, {
                    modelValue: _unref(targetDate),
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_isRef(targetDate) ? (targetDate).value = $event : null)),
                    edited: _unref(editedMove),
                    "data-name": "日報",
                    minDate: _unref(bRange)?.bStdate,
                    maxDate: _unref(bRange)?.bEddate
                  }, null, 8, ["modelValue", "edited", "minDate", "maxDate"]),
                  true
                    ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                        _createElementVNode("span", null, _toDisplayString(home.value.month), 1),
                        _createTextVNode(" の希望シフトの締め日： "),
                        _createElementVNode("span", null, _toDisplayString(home.value.deadline), 1)
                      ]))
                    : _createCommentVNode("", true),
                  _hoisted_14,
                  _createElementVNode("ul", _hoisted_15, [
                    _createElementVNode("li", null, [
                      ((_unref(user)?.browsingAuthority.motionAndStatic ?? 0) >= 2)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            onClick: _cache[3] || (_cache[3] = ($event: any) => (_unref(save)(home.value, _unref(targetDate), _unref(bCode))))
                          }, "保存"))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ]),
                _createElementVNode("ul", _hoisted_16, [
                  _createElementVNode("li", null, [
                    _createElementVNode("table", _hoisted_17, [
                      _hoisted_18,
                      _createElementVNode("tbody", null, [
                        _createElementVNode("tr", null, [
                          _createElementVNode("td", null, [
                            _createVNode(InputSelect, {
                              modelValue: _unref(daily).weather,
                              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(daily).weather) = $event)),
                              list: _unref(weatherList),
                              class: _normalizeClass('w8em ' + _unref(validClass)(_unref(daily).weather.length > 0)),
                              onChange: _cache[5] || (_cache[5] = ($event: any) => (editedMove.value = true))
                            }, null, 8, ["modelValue", "list", "class"]),
                            _createElementVNode("a", {
                              class: "btn-small ref",
                              href: _unref(move).weatherUrl,
                              target: "_blank"
                            }, "参照", 8, _hoisted_19)
                          ]),
                          _createElementVNode("td", null, [
                            _createVNode(InputSelect, {
                              modelValue: _unref(daily).weather1Text,
                              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(daily).weather1Text) = $event)),
                              list: _unref(indoorTempList),
                              class: _normalizeClass('w6em ' + _unref(validClass)(_unref(isEmptyOrFloat)(_unref(daily).weather1Text))),
                              onChange: _cache[7] || (_cache[7] = ($event: any) => (editedMove.value = true))
                            }, null, 8, ["modelValue", "list", "class"])
                          ]),
                          _createElementVNode("td", null, [
                            _createVNode(InputSelect, {
                              modelValue: _unref(daily).weather2Text,
                              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_unref(daily).weather2Text) = $event)),
                              list: _unref(indoorTempList),
                              class: _normalizeClass('w6em ' + _unref(validClass)(_unref(isEmptyOrFloat)(_unref(daily).weather2Text))),
                              onChange: _cache[9] || (_cache[9] = ($event: any) => (editedMove.value = true))
                            }, null, 8, ["modelValue", "list", "class"])
                          ]),
                          _createElementVNode("td", null, [
                            _createVNode(InputSelect, {
                              modelValue: _unref(daily).humidity1Text,
                              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_unref(daily).humidity1Text) = $event)),
                              list: _unref(humidityList),
                              class: _normalizeClass('w6em ' + _unref(validClass)(_unref(isEmptyOrFloat)(_unref(daily).humidity1Text))),
                              onChange: _cache[11] || (_cache[11] = ($event: any) => (editedMove.value = true))
                            }, null, 8, ["modelValue", "list", "class"])
                          ]),
                          _createElementVNode("td", null, [
                            _createVNode(InputSelect, {
                              modelValue: _unref(daily).heatIndexText,
                              "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_unref(daily).heatIndexText) = $event)),
                              list: _unref(wbgtList),
                              class: _normalizeClass('w6em ' + _unref(validClass)(_unref(isEmptyOrIntger)(_unref(daily).heatIndexText))),
                              onChange: _cache[13] || (_cache[13] = ($event: any) => (editedMove.value = true))
                            }, null, 8, ["modelValue", "list", "class"]),
                            _createElementVNode("a", {
                              class: "btn-small ref",
                              href: _unref(move).wbgtUrl,
                              target: "_blank"
                            }, "参照", 8, _hoisted_20)
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("table", _hoisted_21, [
                      _hoisted_22,
                      _createElementVNode("tbody", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(dAlarms), (alarm) => {
                          return (_openBlock(), _createElementBlock("tr", {
                            key: alarm.no
                          }, [
                            (alarm.editStatus === 0)
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                  _createElementVNode("td", null, _toDisplayString(alarm.alarmName), 1),
                                  _createElementVNode("td", _hoisted_23, _toDisplayString(alarm.stTimeText), 1),
                                  _createElementVNode("td", _hoisted_24, _toDisplayString(alarm.edTimeText), 1),
                                  _createElementVNode("td", _hoisted_25, [
                                    _createElementVNode("button", {
                                      class: "btn-small inline-block",
                                      onClick: ($event: any) => (alarm.editStatus = 1)
                                    }, "編集", 8, _hoisted_26)
                                  ])
                                ], 64))
                              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                  _createElementVNode("td", null, [
                                    _withDirectives(_createElementVNode("input", {
                                      "onUpdate:modelValue": ($event: any) => ((alarm.alarmName) = $event),
                                      class: _normalizeClass(["full-ref", _unref(validClass)(alarm.alarmName.length > 0)]),
                                      type: "text"
                                    }, null, 10, _hoisted_27), [
                                      [_vModelText, alarm.alarmName]
                                    ]),
                                    _createElementVNode("a", {
                                      class: "btn-small ref",
                                      href: _unref(move).alertUrl,
                                      target: "_blank"
                                    }, "参照", 8, _hoisted_28)
                                  ]),
                                  _createElementVNode("td", _hoisted_29, [
                                    _withDirectives(_createElementVNode("input", {
                                      "onUpdate:modelValue": ($event: any) => ((alarm.stTimeText) = $event),
                                      type: "time"
                                    }, null, 8, _hoisted_30), [
                                      [_vModelText, alarm.stTimeText]
                                    ])
                                  ]),
                                  _createElementVNode("td", _hoisted_31, [
                                    _withDirectives(_createElementVNode("input", {
                                      "onUpdate:modelValue": ($event: any) => ((alarm.edTimeText) = $event),
                                      type: "time"
                                    }, null, 8, _hoisted_32), [
                                      [_vModelText, alarm.edTimeText]
                                    ])
                                  ]),
                                  _createElementVNode("td", _hoisted_33, [
                                    _createElementVNode("button", {
                                      class: "btn-small inline-block",
                                      disabled: alarm.alarmName.length === 0,
                                      onClick: ($event: any) => ((alarm.editStatus = 0), (editedMove.value = true))
                                    }, " 確定 ", 8, _hoisted_34),
                                    _createElementVNode("button", {
                                      class: "btn-small",
                                      onClick: ($event: any) => (_unref(deleteAlarm)(home.value, alarm.no), (editedMove.value = true))
                                    }, "削除", 8, _hoisted_35)
                                  ])
                                ], 64))
                          ]))
                        }), 128)),
                        _createElementVNode("tr", null, [
                          _hoisted_36,
                          _hoisted_37,
                          _hoisted_38,
                          _createElementVNode("td", _hoisted_39, [
                            _hoisted_40,
                            _createElementVNode("button", {
                              class: "btn-small add",
                              onClick: _cache[14] || (_cache[14] = ($event: any) => (_unref(addAlarm)(home.value, _unref(targetDate), _unref(bCode))))
                            }, "追加")
                          ])
                        ])
                      ])
                    ]),
                    (!_unref(isOffice))
                      ? (_openBlock(), _createElementBlock("table", _hoisted_41, [
                          _hoisted_42,
                          _createElementVNode("tbody", null, [
                            _createElementVNode("tr", null, [
                              _createElementVNode("td", null, _toDisplayString(_unref(move).cScheduleCountD) + "名", 1),
                              _createElementVNode("td", null, _toDisplayString(_unref(move).cPunchCountD) + "名", 1),
                              _createElementVNode("td", null, _toDisplayString(_unref(move).cScheduleCountN) + "名", 1),
                              _createElementVNode("td", null, _toDisplayString(_unref(move).cPunchCountN) + "名", 1),
                              _createElementVNode("td", null, _toDisplayString(_unref(move).sScheduleCountD) + "名", 1),
                              _createElementVNode("td", null, _toDisplayString(_unref(move).sPunchCountD) + "名", 1),
                              _createElementVNode("td", null, _toDisplayString(_unref(move).sScheduleCountN) + "名", 1),
                              _createElementVNode("td", null, _toDisplayString(_unref(move).sPunchCountN) + "名", 1),
                              _createElementVNode("td", null, [
                                _createVNode(SelectStaffSearch, {
                                  modelValue: _unref(daily).todayReaderSCode,
                                  "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_unref(daily).todayReaderSCode) = $event)),
                                  "staff-opts": _unref(sssStaffOpts),
                                  "base-opts": _unref(sssBaseOpts),
                                  placeholder: "検索",
                                  class: _normalizeClass(_unref(validClass)(_unref(daily).todayReaderSCode > 0)),
                                  onChange: _cache[16] || (_cache[16] = ($event: any) => (editedMove.value = true))
                                }, null, 8, ["modelValue", "staff-opts", "base-opts", "class"])
                              ])
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("table", _hoisted_43, [
                      _hoisted_44,
                      _createElementVNode("tbody", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(dEvents), (ev, i) => {
                          return (_openBlock(), _createElementBlock("tr", { key: i }, [
                            _createElementVNode("td", {
                              class: _normalizeClass(i === 0 ? 'v-top' : '')
                            }, _toDisplayString(ev.itemName), 3),
                            _createElementVNode("td", {
                              class: _normalizeClass(i === 0 ? 'v-top' : '')
                            }, _toDisplayString(_unref(toMMdd)(ev.targetDateFrom) + '～' + _unref(toMMdd)(ev.targetDateTo)), 3),
                            _createElementVNode("td", {
                              class: _normalizeClass(i === 0 ? 'v-top' : '')
                            }, _toDisplayString(ev.itemUrl), 3),
                            _createElementVNode("td", {
                              class: _normalizeClass(i === 0 ? 'v-top' : '')
                            }, [
                              _createElementVNode("button", {
                                class: "btn-small add",
                                onClick: ($event: any) => (_unref(openEditEventDialog)(home.value, ev))
                              }, "編集", 8, _hoisted_45)
                            ], 2)
                          ]))
                        }), 128)),
                        _createElementVNode("tr", null, [
                          _hoisted_46,
                          _createElementVNode("td", null, [
                            _createElementVNode("button", {
                              class: "btn-small add",
                              onClick: _cache[17] || (_cache[17] = ($event: any) => (_unref(openAddEventDialog)(home.value, _unref(bCode))))
                            }, "追加")
                          ])
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("li", _hoisted_47, [
                    _createElementVNode("div", _hoisted_48, [
                      _createTextVNode(" 申し送り事項（報連相） "),
                      _createElementVNode("span", _hoisted_49, [
                        _createElementVNode("button", {
                          class: "btn-small add",
                          onClick: _cache[18] || (_cache[18] = ($event: any) => (_unref(addInform)(home.value, _unref(bCode))))
                        }, "追加")
                      ])
                    ]),
                    _createElementVNode("table", _hoisted_50, [
                      _createElementVNode("thead", null, [
                        _createElementVNode("tr", null, [
                          _hoisted_51,
                          _hoisted_52,
                          (_unref(isHasClass))
                            ? (_openBlock(), _createElementBlock("th", _hoisted_53, "クラス"))
                            : _createCommentVNode("", true),
                          _hoisted_54,
                          _hoisted_55,
                          _hoisted_56,
                          _hoisted_57,
                          _hoisted_58,
                          _hoisted_59
                        ])
                      ]),
                      _createElementVNode("tbody", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(dInforms).filter(
                      v =>
                        !_unref(isHasClass) ||
                        _unref(className) === _unref(classAll) ||
                        v.targetCCode <= 0 ||
                        _unref(toRealClassName)(_unref(className)) === _unref(childClassOpts)[v.targetCCode]
                    ), (inform) => {
                          return (_openBlock(), _createElementBlock("tr", {
                            key: inform.no
                          }, [
                            (inform.editStatus === 0)
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                  _createElementVNode("td", null, _toDisplayString(inform.titleName), 1),
                                  _createElementVNode("td", null, _toDisplayString(_unref(toDInformName)(inform.targetCCode, _unref(childNameRec))), 1),
                                  (_unref(isHasClass))
                                    ? (_openBlock(), _createElementBlock("td", _hoisted_60, _toDisplayString(_unref(toDInformName)(inform.targetCCode, _unref(childClassOpts))), 1))
                                    : _createCommentVNode("", true),
                                  _createElementVNode("td", null, _toDisplayString(_unref(toDInformName)(inform.targetSCode, _unref(staffNameRec))), 1),
                                  _createElementVNode("td", null, _toDisplayString(inform.itemName), 1),
                                  _createElementVNode("td", null, _toDisplayString(inform.contents), 1),
                                  _createElementVNode("td", null, _toDisplayString(inform.makeDateText), 1),
                                  _createElementVNode("td", null, _toDisplayString(_unref(staffNameRec)[inform.sCode] ?? '-'), 1),
                                  _createElementVNode("td", null, [
                                    _createElementVNode("div", _hoisted_61, [
                                      _createElementVNode("button", {
                                        class: "btn-small edit",
                                        onClick: ($event: any) => (inform.editStatus = 1)
                                      }, "編集", 8, _hoisted_62)
                                    ])
                                  ])
                                ], 64))
                              : (inform.editStatus === 1)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                    _createElementVNode("td", null, [
                                      _createVNode(InputListEdit, {
                                        val: inform.titleName,
                                        "onUpdate:val": ($event: any) => ((inform.titleName) = $event),
                                        list: _unref(informTitleList),
                                        "onUpdate:list": _cache[19] || (_cache[19] = ($event: any) => (_isRef(informTitleList) ? (informTitleList).value = $event : null)),
                                        class: _normalizeClass('w8em' + _unref(validClass)(_unref(isValidDInformTitleName)(inform.titleName)))
                                      }, null, 8, ["val", "onUpdate:val", "list", "class"])
                                    ]),
                                    _createElementVNode("td", null, [
                                      _createVNode(SelectBoxNum, {
                                        modelValue: inform.targetCCode,
                                        "onUpdate:modelValue": ($event: any) => ((inform.targetCCode) = $event),
                                        list: _unref(childNameOpts)
                                      }, null, 8, ["modelValue", "onUpdate:modelValue", "list"])
                                    ]),
                                    (_unref(isHasClass))
                                      ? (_openBlock(), _createElementBlock("td", _hoisted_63, _toDisplayString(_unref(toDInformName)(inform.targetCCode, _unref(childClassOpts))), 1))
                                      : _createCommentVNode("", true),
                                    _createElementVNode("td", null, [
                                      _createElementVNode("div", _hoisted_64, [
                                        _withDirectives(_createElementVNode("select", {
                                          "onUpdate:modelValue": ($event: any) => ((inform.targetSCode) = $event)
                                        }, [
                                          _hoisted_66,
                                          _hoisted_67,
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(staffNameOpts), (opt) => {
                                            return (_openBlock(), _createElementBlock("option", {
                                              key: opt.value,
                                              value: opt.value
                                            }, _toDisplayString(opt.text), 9, _hoisted_68))
                                          }), 128))
                                        ], 8, _hoisted_65), [
                                          [_vModelSelect, inform.targetSCode]
                                        ])
                                      ])
                                    ]),
                                    _createElementVNode("td", null, [
                                      _createVNode(InputListEdit, {
                                        val: inform.itemName,
                                        "onUpdate:val": ($event: any) => ((inform.itemName) = $event),
                                        list: _unref(informItemList),
                                        "onUpdate:list": _cache[20] || (_cache[20] = ($event: any) => (_isRef(informItemList) ? (informItemList).value = $event : null)),
                                        class: _normalizeClass('w8em' + _unref(validClass)(_unref(isValidDInformItemName)(inform.itemName)))
                                      }, null, 8, ["val", "onUpdate:val", "list", "class"])
                                    ]),
                                    _createElementVNode("td", null, [
                                      _createVNode(InputListEdit, {
                                        val: inform.contents,
                                        "onUpdate:val": ($event: any) => ((inform.contents) = $event),
                                        list: _unref(informContentsList),
                                        "onUpdate:list": _cache[21] || (_cache[21] = ($event: any) => (_isRef(informContentsList) ? (informContentsList).value = $event : null)),
                                        class: _normalizeClass('w8em' + _unref(validClass)(_unref(isValidDInformContents)(inform.contents)))
                                      }, null, 8, ["val", "onUpdate:val", "list", "class"])
                                    ]),
                                    _createElementVNode("td", null, _toDisplayString(inform.makeDateText), 1),
                                    _createElementVNode("td", null, [
                                      _createElementVNode("div", _hoisted_69, [
                                        _withDirectives(_createElementVNode("select", {
                                          "onUpdate:modelValue": ($event: any) => ((inform.sCode) = $event),
                                          class: _normalizeClass(_unref(toValidClassNum)(inform.sCode))
                                        }, [
                                          _hoisted_71,
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(staffNameOpts), (opt) => {
                                            return (_openBlock(), _createElementBlock("option", {
                                              key: opt.value,
                                              value: opt.value
                                            }, _toDisplayString(opt.text), 9, _hoisted_72))
                                          }), 128))
                                        ], 10, _hoisted_70), [
                                          [_vModelSelect, inform.sCode]
                                        ])
                                      ])
                                    ]),
                                    _createElementVNode("td", null, [
                                      _createElementVNode("div", _hoisted_73, [
                                        _createElementVNode("button", {
                                          class: "btn-small save",
                                          onClick: ($event: any) => (_unref(saveAndLoadInform)(inform, home.value, _unref(toDateKey)(_unref(targetDate)), _unref(bCode))),
                                          disabled: !_unref(isValidInform)(inform)
                                        }, " 保存 ", 8, _hoisted_74),
                                        _createElementVNode("button", {
                                          class: "btn-small delete",
                                          onClick: ($event: any) => (_unref(deleteAndLoadInform)(home.value, inform.no, _unref(toDateKey)(_unref(targetDate)), _unref(bCode)))
                                        }, " 削除 ", 8, _hoisted_75)
                                      ])
                                    ])
                                  ], 64))
                                : _createCommentVNode("", true)
                          ]))
                        }), 128))
                      ])
                    ])
                  ]),
                  _createElementVNode("li", _hoisted_76, [
                    (!_unref(isOffice))
                      ? (_openBlock(), _createElementBlock("a", _hoisted_77, "児童の登降園状況"))
                      : _createCommentVNode("", true),
                    _hoisted_78,
                    (!_unref(isOffice))
                      ? (_openBlock(), _createElementBlock("a", _hoisted_79, "児童の体調管理（病気・怪我）"))
                      : _createCommentVNode("", true),
                    _hoisted_80,
                    (!_unref(isOffice))
                      ? (_openBlock(), _createElementBlock("a", _hoisted_81, "アレルギー/未食 管理"))
                      : _createCommentVNode("", true)
                  ]),
                  (!_unref(isOffice))
                    ? (_openBlock(), _createElementBlock("li", _hoisted_82, [
                        _createElementVNode("div", _hoisted_83, [
                          _createTextVNode(" 児童の体調管理（病気・怪我） "),
                          _createElementVNode("span", _hoisted_84, [
                            _createElementVNode("button", {
                              class: "btn-small add",
                              onClick: _cache[22] || (_cache[22] = ($event: any) => (_unref(addChildCondition)(home.value)))
                            }, "追加")
                          ])
                        ]),
                        _createElementVNode("table", _hoisted_85, [
                          _createElementVNode("thead", null, [
                            _createElementVNode("tr", null, [
                              _hoisted_86,
                              (_unref(isHasClass))
                                ? (_openBlock(), _createElementBlock("th", _hoisted_87, "クラス"))
                                : _createCommentVNode("", true),
                              _hoisted_88,
                              _hoisted_89,
                              _hoisted_90,
                              _hoisted_91,
                              _hoisted_92,
                              _hoisted_93,
                              _hoisted_94
                            ])
                          ]),
                          _createElementVNode("tbody", null, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(childConds).filter(
                      v => !_unref(isHasClass) || _unref(className) === _unref(classAll) || _unref(toRealClassName)(_unref(className)) === _unref(childClassOpts)[v.cCode]
                    ), (child) => {
                              return (_openBlock(), _createElementBlock("tr", {
                                key: child.no
                              }, [
                                (child.editStatus === 0)
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                      _createElementVNode("td", null, _toDisplayString(_unref(childNameRec)[child.cCode]), 1),
                                      (_unref(isHasClass))
                                        ? (_openBlock(), _createElementBlock("td", _hoisted_95, _toDisplayString(_unref(childClassOpts)[child.cCode]), 1))
                                        : _createCommentVNode("", true),
                                      _createElementVNode("td", null, _toDisplayString(child.time), 1),
                                      _createElementVNode("td", null, _toDisplayString(child.case), 1),
                                      _createElementVNode("td", null, _toDisplayString(child.situation), 1),
                                      _createElementVNode("td", null, _toDisplayString(child.action), 1),
                                      _createElementVNode("td", null, _toDisplayString(child.sCode === -1
                            ? 'なし'
                            : child.sCode === 0
                            ? '全員'
                            : _unref(staffNameOpts).find(x => x.value === child.sCode)?.text ?? '-'), 1),
                                      _createElementVNode("td", null, _toDisplayString(child.contact), 1),
                                      _createElementVNode("td", null, [
                                        _createElementVNode("div", _hoisted_96, [
                                          _createElementVNode("button", {
                                            class: "btn-small edit",
                                            onClick: ($event: any) => (child.editStatus = 1)
                                          }, "編集", 8, _hoisted_97)
                                        ])
                                      ])
                                    ], 64))
                                  : (child.editStatus === 1)
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                        _createElementVNode("td", null, [
                                          _createElementVNode("div", _hoisted_98, [
                                            _withDirectives(_createElementVNode("select", {
                                              "onUpdate:modelValue": ($event: any) => ((child.cCode) = $event),
                                              class: _normalizeClass(_unref(toValidClassNum)(child.cCode))
                                            }, [
                                              _hoisted_100,
                                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.keys(_unref(childNameRec)), (key) => {
                                                return (_openBlock(), _createElementBlock("option", {
                                                  key: key,
                                                  value: key
                                                }, _toDisplayString(_unref(childNameRec)[Number(key)]), 9, _hoisted_101))
                                              }), 128))
                                            ], 10, _hoisted_99), [
                                              [
                                                _vModelSelect,
                                                child.cCode,
                                                void 0,
                                                { number: true }
                                              ]
                                            ])
                                          ])
                                        ]),
                                        (_unref(isHasClass))
                                          ? (_openBlock(), _createElementBlock("td", _hoisted_102, _toDisplayString(_unref(childClassOpts)[child.cCode]), 1))
                                          : _createCommentVNode("", true),
                                        _createElementVNode("td", null, [
                                          _withDirectives(_createElementVNode("input", {
                                            "onUpdate:modelValue": ($event: any) => ((child.time) = $event),
                                            type: "time",
                                            class: _normalizeClass(_unref(toValidClassStr)(child.time))
                                          }, null, 10, _hoisted_103), [
                                            [_vModelText, child.time]
                                          ])
                                        ]),
                                        _createElementVNode("td", null, [
                                          _createVNode(InputListEdit, {
                                            val: child.case,
                                            "onUpdate:val": ($event: any) => ((child.case) = $event),
                                            list: _unref(caseList),
                                            "onUpdate:list": _cache[23] || (_cache[23] = ($event: any) => (_isRef(caseList) ? (caseList).value = $event : null)),
                                            class: _normalizeClass('w8em ' + _unref(toValidClassStr)(child.case))
                                          }, null, 8, ["val", "onUpdate:val", "list", "class"])
                                        ]),
                                        _createElementVNode("td", null, [
                                          _createVNode(InputListEdit, {
                                            val: child.situation,
                                            "onUpdate:val": ($event: any) => ((child.situation) = $event),
                                            list: _unref(situationList),
                                            "onUpdate:list": _cache[24] || (_cache[24] = ($event: any) => (_isRef(situationList) ? (situationList).value = $event : null)),
                                            class: _normalizeClass('w8em ' + _unref(validClass)(_unref(isValidCHealthSituation)(child.situation)))
                                          }, null, 8, ["val", "onUpdate:val", "list", "class"])
                                        ]),
                                        _createElementVNode("td", null, [
                                          _createVNode(InputListEdit, {
                                            val: child.action,
                                            "onUpdate:val": ($event: any) => ((child.action) = $event),
                                            list: _unref(actionList),
                                            "onUpdate:list": _cache[25] || (_cache[25] = ($event: any) => (_isRef(actionList) ? (actionList).value = $event : null)),
                                            class: _normalizeClass('w8em ' + _unref(validClass)(_unref(isValidCHealthAction)(child.action)))
                                          }, null, 8, ["val", "onUpdate:val", "list", "class"])
                                        ]),
                                        _createElementVNode("td", null, [
                                          _createElementVNode("div", _hoisted_104, [
                                            _withDirectives(_createElementVNode("select", {
                                              "onUpdate:modelValue": ($event: any) => ((child.sCode) = $event),
                                              class: _normalizeClass(_unref(toValidClassNum)(child.sCode))
                                            }, [
                                              _hoisted_106,
                                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(staffNameOpts), (opt) => {
                                                return (_openBlock(), _createElementBlock("option", {
                                                  key: opt.value,
                                                  value: opt.value
                                                }, _toDisplayString(opt.text), 9, _hoisted_107))
                                              }), 128))
                                            ], 10, _hoisted_105), [
                                              [
                                                _vModelSelect,
                                                child.sCode,
                                                void 0,
                                                { number: true }
                                              ]
                                            ])
                                          ])
                                        ]),
                                        _createElementVNode("td", null, [
                                          _createVNode(InputListEdit, {
                                            val: child.contact,
                                            "onUpdate:val": ($event: any) => ((child.contact) = $event),
                                            list: _unref(contactList),
                                            "onUpdate:list": _cache[26] || (_cache[26] = ($event: any) => (_isRef(contactList) ? (contactList).value = $event : null)),
                                            class: _normalizeClass('w8em ' + _unref(validClass)(_unref(isValidCHealthContact)(child.contact)))
                                          }, null, 8, ["val", "onUpdate:val", "list", "class"])
                                        ]),
                                        _createElementVNode("td", null, [
                                          _createElementVNode("div", _hoisted_108, [
                                            _createElementVNode("button", {
                                              class: "btn-small save",
                                              onClick: ($event: any) => (_unref(saveAndLoadChildHealth)(child, home.value, _unref(toDateKey)(_unref(targetDate)), _unref(bCode))),
                                              disabled: !_unref(isValidChildCondtion)(child)
                                            }, " 保存 ", 8, _hoisted_109),
                                            _createElementVNode("button", {
                                              class: "btn-small delete",
                                              onClick: ($event: any) => (_unref(deleteAndLoadChildCondtion)(home.value, child.no, _unref(toDateKey)(_unref(targetDate)), _unref(bCode)))
                                            }, " 削除 ", 8, _hoisted_110)
                                          ])
                                        ])
                                      ], 64))
                                    : _createCommentVNode("", true)
                              ]))
                            }), 128))
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (!_unref(isOffice))
                    ? (_openBlock(), _createElementBlock("li", _hoisted_111, [
                        _createElementVNode("div", _hoisted_112, [
                          _createTextVNode(" 児童の登降園状況 "),
                          _createElementVNode("span", _hoisted_113, [
                            _createVNode(_component_router_link, {
                              class: "btn-small",
                              to: { name: 'children-daily' }
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode("予定・実績の変更はこちら")
                              ]),
                              _: 1
                            })
                          ])
                        ]),
                        _createElementVNode("table", _hoisted_114, [
                          _createElementVNode("thead", null, [
                            _createElementVNode("tr", null, [
                              _hoisted_115,
                              (_unref(isHasClass))
                                ? (_openBlock(), _createElementBlock("th", _hoisted_116, "クラス"))
                                : _createCommentVNode("", true),
                              _hoisted_117,
                              _hoisted_118,
                              _createElementVNode("th", _hoisted_119, [
                                _createTextVNode(" 本日の状況 "),
                                _createElementVNode("div", null, "タイトル・内容 (最大 " + _toDisplayString(_unref(contentLength)) + "文字)", 1)
                              ]),
                              _createElementVNode("th", _hoisted_120, [
                                _createTextVNode(" 現在の動静 "),
                                _createElementVNode("div", null, "(最大 " + _toDisplayString(_unref(statusLength)) + "文字)", 1)
                              ]),
                              _hoisted_121
                            ]),
                            _hoisted_122
                          ]),
                          _createElementVNode("tbody", null, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(childInOuts).filter(
                      v => !_unref(isHasClass) || _unref(className) === _unref(classAll) || _unref(toRealClassName)(_unref(className)) === _unref(childClassOpts)[v.cCode]
                    ), (child, i) => {
                              return (_openBlock(), _createElementBlock("tr", {
                                key: i,
                                class: _normalizeClass(
                        'fromToClass' + _unref(toBackStatusId)(child.punchFromTo, child.memoTitle, _unref(ChildTitleStatus).late, _unref(ChildTitleStatus).cancel)
                      )
                              }, [
                                _createElementVNode("td", null, _toDisplayString(child.cName), 1),
                                (_unref(isHasClass))
                                  ? (_openBlock(), _createElementBlock("td", _hoisted_123, _toDisplayString(_unref(childClassOpts)[child.cCode]), 1))
                                  : _createCommentVNode("", true),
                                _createElementVNode("td", null, _toDisplayString(_unref(indexToTimeN)(child.fromKoma) + ' ～ ' + _unref(indexToTimeN)(child.toKoma)), 1),
                                _createElementVNode("td", null, [
                                  _createElementVNode("div", _hoisted_124, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(child.scheduleMeals, (meal, i) => {
                                      return (_openBlock(), _createElementBlock("button", {
                                        key: i,
                                        class: _normalizeClass({ on: meal === 1 }),
                                        disabled: !_unref(isEditableScheduleMeal)(child, i, _unref(targetDate)),
                                        onClick: ($event: any) => (
                                _unref(toggleScheduleMeal)(child, i),
                                  _unref(saveScheduleMeal)(home.value, child.cCode, i + 1, child.scheduleMeals[i], _unref(bCode), _unref(targetDate))
                              )
                                      }, null, 10, _hoisted_125))
                                    }), 128))
                                  ])
                                ]),
                                _createElementVNode("td", null, _toDisplayString(child.punchTimeA) + " ～ " + _toDisplayString(child.punchTimeB), 1),
                                _createElementVNode("td", null, _toDisplayString(_unref(toStatusMsgChild)(child.punchFromTo, _unref(toMemoTitle)(home.value.cmTitleOpts, child.memoTitle))), 1),
                                _createElementVNode("td", null, _toDisplayString(_unref(toTemperText)(child.punchTemper)), 1),
                                _createElementVNode("td", null, [
                                  _createElementVNode("div", _hoisted_126, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(child.resultMeals, (meal, i) => {
                                      return (_openBlock(), _createElementBlock("button", {
                                        key: i,
                                        class: _normalizeClass(['', 'on', 'noteat'][meal]),
                                        disabled: !_unref(isEditableResultMeal)(child, i, _unref(targetDate)),
                                        onClick: ($event: any) => (
                                _unref(incResultMeal)(child, i), _unref(saveResultMeal)(home.value, child.cCode, i + 1, child.resultMeals[i], _unref(bCode), _unref(targetDate))
                              )
                                      }, null, 10, _hoisted_127))
                                    }), 128))
                                  ])
                                ]),
                                _createElementVNode("td", _hoisted_128, [
                                  (_unref(targetDate).getTime() === child.date?.getTime())
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                        _createVNode(SelectBoxNum, {
                                          modelValue: child.memoTitle,
                                          "onUpdate:modelValue": ($event: any) => ((child.memoTitle) = $event),
                                          list: _unref(childMemoTitleOpts),
                                          class: _normalizeClass(!child.memoTitle ? 'ng' : '')
                                        }, null, 8, ["modelValue", "onUpdate:modelValue", "list", "class"]),
                                        _withDirectives(_createElementVNode("textarea", {
                                          "onUpdate:modelValue": ($event: any) => ((child.memoContent) = $event),
                                          placeholder: "バス遅延のため・家庭の事情のため等",
                                          maxlength: _unref(contentLength),
                                          class: _normalizeClass(!child.memoContent ? 'ng' : '')
                                        }, null, 10, _hoisted_129), [
                                          [_vModelText, child.memoContent]
                                        ]),
                                        _createElementVNode("button", {
                                          class: "btn-small",
                                          onClick: ($event: any) => (_unref(saveMemoChild)(child, home.value, _unref(toDateKey)(_unref(targetDate)), _unref(bCode)))
                                        }, "保存", 8, _hoisted_130)
                                      ], 64))
                                    : (_unref(addDate)(_unref(targetDate), -1).getTime() === child.date?.getTime())
                                      ? (_openBlock(), _createBlock(_component_templete, { key: 1 }, {
                                          default: _withCtx(() => [
                                            _createElementVNode("div", _hoisted_131, [
                                              _createElementVNode("span", null, _toDisplayString(_unref(staffMemoTitleOpts).find(v => v.value === child.memoPrevTitle)?.text), 1),
                                              _createTextVNode(" 「 "),
                                              _createElementVNode("span", null, _toDisplayString(!child.memoPrevContent ? '-' : child.memoPrevContent), 1),
                                              _createTextVNode(" 」 ")
                                            ])
                                          ]),
                                          _: 2
                                        }, 1024))
                                      : _createCommentVNode("", true)
                                ]),
                                _createElementVNode("td", null, [
                                  _createElementVNode("div", _hoisted_132, [
                                    _withDirectives(_createElementVNode("input", {
                                      "onUpdate:modelValue": ($event: any) => ((child.memoStatus) = $event),
                                      type: "text",
                                      maxlength: _unref(statusLength),
                                      class: _normalizeClass(!child.memoStatus ? 'ng' : '')
                                    }, null, 10, _hoisted_133), [
                                      [_vModelText, child.memoStatus]
                                    ]),
                                    _createElementVNode("button", {
                                      class: "btn-small",
                                      onClick: ($event: any) => (_unref(saveMemoStatusChild)(child, home.value, _unref(toDateKey)(_unref(targetDate)), _unref(bCode)))
                                    }, "保存", 8, _hoisted_134)
                                  ])
                                ]),
                                _createElementVNode("td", null, [
                                  (_unref(isEnabledRepunch)(home.value, child.cCode, _unref(Punch).In, _unref(targetDate)))
                                    ? (_openBlock(), _createElementBlock("button", {
                                        key: 0,
                                        class: "btn-small inline-flex",
                                        onClick: ($event: any) => (
                            _unref(openRepunchDialog)(
                              repunchCtrl.value,
                              true,
                              child.cCode,
                              child.cName,
                              true,
                              _unref(repunchInitDate)(home.value, child.cCode)!, //< 打刻がない時、ボタンが表示されないため 抑制でOK
                              _unref(lastPunchDate)(home.value, child.cCode, _unref(Punch).In)!, //< 同上
                              _unref(lastPunchDate)(home.value, child.cCode, _unref(Punch).Out)
                            )
                          )
                                      }, " 登園打刻を忘れた場合 ", 8, _hoisted_135))
                                    : _createCommentVNode("", true),
                                  (_unref(isEnabledRepunch)(home.value, child.cCode, _unref(Punch).Out, _unref(targetDate)))
                                    ? (_openBlock(), _createElementBlock("button", {
                                        key: 1,
                                        class: "btn-small inline-flex",
                                        onClick: ($event: any) => (
                            _unref(openRepunchDialog)(
                              repunchCtrl.value,
                              false,
                              child.cCode,
                              child.cName,
                              true,
                              _unref(repunchInitDate)(home.value, child.cCode)!, //< 打刻がない時、ボタンが表示されないため 抑制でOK
                              _unref(lastPunchDate)(home.value, child.cCode, _unref(Punch).In)!, //< 同上
                              _unref(lastPunchDate)(home.value, child.cCode, _unref(Punch).Out)
                            )
                          )
                                      }, " 降園打刻を忘れた場合 ", 8, _hoisted_136))
                                    : _createCommentVNode("", true)
                                ])
                              ], 2))
                            }), 128))
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (!_unref(isOffice))
                    ? (_openBlock(), _createElementBlock("li", _hoisted_137, [
                        _hoisted_138,
                        _createElementVNode("table", _hoisted_139, [
                          _createElementVNode("thead", null, [
                            _createElementVNode("tr", null, [
                              _hoisted_140,
                              (_unref(isHasClass))
                                ? (_openBlock(), _createElementBlock("th", _hoisted_141, "クラス"))
                                : _createCommentVNode("", true),
                              _hoisted_142,
                              _hoisted_143,
                              _hoisted_144,
                              _hoisted_145,
                              _hoisted_146
                            ])
                          ]),
                          _createElementVNode("tbody", null, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(cAllergys).filter(
                      v => !_unref(isHasClass) || _unref(className) === _unref(classAll) || _unref(toRealClassName)(_unref(className)) === _unref(childClassOpts)[v.cCode]
                    ), (allergy) => {
                              return (_openBlock(), _createElementBlock("tr", {
                                key: allergy.no
                              }, [
                                _createElementVNode("td", null, _toDisplayString(_unref(childNameRec)[allergy.cCode]), 1),
                                (_unref(isHasClass))
                                  ? (_openBlock(), _createElementBlock("td", _hoisted_147, _toDisplayString(_unref(childClassOpts)[allergy.cCode]), 1))
                                  : _createCommentVNode("", true),
                                _createElementVNode("td", null, _toDisplayString(['', 'アレルギー', '未食'][allergy.case]), 1),
                                _createElementVNode("td", null, _toDisplayString(allergy.foods), 1),
                                _createElementVNode("td", null, _toDisplayString(['', '朝食', '午前おやつ', '昼食', '午後おやつ', '夕食', '夜食'][allergy.cMeal]), 1),
                                _createElementVNode("td", null, _toDisplayString(['無', '有'][allergy.yorN]), 1),
                                _createElementVNode("td", null, [
                                  _createElementVNode("label", null, [
                                    _withDirectives(_createElementVNode("input", {
                                      "onUpdate:modelValue": ($event: any) => ((allergy.checkB) = $event),
                                      class: "checkbox-input",
                                      type: "checkbox",
                                      onChange: ($event: any) => (_unref(saveAndLoadAllergy)(allergy, home.value, _unref(toDateKey)(_unref(targetDate)), _unref(bCode)))
                                    }, null, 40, _hoisted_148), [
                                      [_vModelCheckbox, allergy.checkB]
                                    ]),
                                    _hoisted_149
                                  ])
                                ])
                              ]))
                            }), 128))
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("li", _hoisted_150, [
                    _createElementVNode("div", _hoisted_151, [
                      _createTextVNode(" 従事者の勤務状況 "),
                      _createElementVNode("span", _hoisted_152, [
                        _createVNode(_component_router_link, {
                          class: "btn-small",
                          to: { name: 'shift-plan-daily' }
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("予定の変更はこちら")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_router_link, {
                          class: "btn-small",
                          to: { name: 'shift-results-daily' }
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("実績の変更はこちら")
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    _createElementVNode("table", _hoisted_153, [
                      _createElementVNode("thead", null, [
                        _createElementVNode("tr", null, [
                          _hoisted_154,
                          _hoisted_155,
                          _hoisted_156,
                          _createElementVNode("th", _hoisted_157, [
                            _createTextVNode(" 本日の状況 "),
                            _createElementVNode("div", null, "タイトル・内容 (最大 " + _toDisplayString(_unref(contentLength)) + "文字)", 1)
                          ]),
                          _createElementVNode("th", _hoisted_158, [
                            _createTextVNode(" 現在の動静 "),
                            _createElementVNode("div", null, "(最大 " + _toDisplayString(_unref(statusLength)) + "文字)", 1)
                          ])
                        ]),
                        _hoisted_159
                      ]),
                      _createElementVNode("tbody", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(staffInOuts), (staff, i) => {
                          return (_openBlock(), _createElementBlock("tr", {
                            key: i,
                            class: _normalizeClass(
                        'fromToClass' + _unref(toBackStatusId)(staff.punchFromTo, staff.memoTitle, _unref(StaffTitleStatus).late, _unref(StaffTitleStatus).cancel)
                      )
                          }, [
                            _createElementVNode("td", null, _toDisplayString(staff.sName), 1),
                            _createElementVNode("td", null, _toDisplayString(_unref(indexToTimeN)(staff.fromKoma) + ' ～ ' + _unref(indexToTimeN)(staff.toKoma)) + " " + _toDisplayString(_unref(toCategoryText)(home.value.categoryOpts, staff.scheduleCategory)), 1),
                            _createElementVNode("td", null, _toDisplayString(staff.punchTimeA) + " ～ " + _toDisplayString(staff.punchTimeB) + " " + _toDisplayString(_unref(toCategoryText)(home.value.categoryOpts, staff.punchCategory)), 1),
                            _createElementVNode("td", null, _toDisplayString(_unref(toStatusMsgStaff)(staff.punchFromTo, _unref(toMemoTitle)(home.value.smTitleOpts, staff.memoTitle))), 1),
                            _createElementVNode("td", null, _toDisplayString(_unref(toTemperText)(staff.punchTemper)), 1),
                            _createElementVNode("td", _hoisted_160, [
                              (_unref(targetDate).getTime() === staff.date?.getTime())
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    _createVNode(SelectBoxNum, {
                                      modelValue: staff.memoTitle,
                                      "onUpdate:modelValue": ($event: any) => ((staff.memoTitle) = $event),
                                      list: _unref(staffMemoTitleOpts),
                                      class: _normalizeClass(!staff.memoTitle ? 'ng' : '')
                                    }, null, 8, ["modelValue", "onUpdate:modelValue", "list", "class"]),
                                    _withDirectives(_createElementVNode("textarea", {
                                      "onUpdate:modelValue": ($event: any) => ((staff.memoContent) = $event),
                                      placeholder: "バス遅延のため・私用のため等",
                                      maxlength: _unref(contentLength),
                                      class: _normalizeClass(!staff.memoContent ? 'ng' : '')
                                    }, null, 10, _hoisted_161), [
                                      [_vModelText, staff.memoContent]
                                    ]),
                                    _createElementVNode("button", {
                                      class: "btn-small",
                                      onClick: ($event: any) => (_unref(saveMemoStaff)(staff, home.value, _unref(toDateKey)(_unref(targetDate)), _unref(bCode)))
                                    }, "保存", 8, _hoisted_162)
                                  ], 64))
                                : (_unref(addDate)(_unref(targetDate), -1).getTime() === staff.date?.getTime())
                                  ? (_openBlock(), _createBlock(_component_templete, { key: 1 }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("div", _hoisted_163, [
                                          _createElementVNode("span", null, _toDisplayString(_unref(staffMemoTitleOpts).find(v => v.value === staff.memoPrevTitle)?.text), 1),
                                          _createTextVNode(" 「 "),
                                          _createElementVNode("span", null, _toDisplayString(!staff.memoPrevContent ? '-' : staff.memoPrevContent), 1),
                                          _createTextVNode(" 」 ")
                                        ])
                                      ]),
                                      _: 2
                                    }, 1024))
                                  : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("td", null, [
                              _createElementVNode("div", _hoisted_164, [
                                _withDirectives(_createElementVNode("input", {
                                  "onUpdate:modelValue": ($event: any) => ((staff.memoStatus) = $event),
                                  type: "text",
                                  maxlength: _unref(statusLength),
                                  class: _normalizeClass(!staff.memoStatus ? 'ng' : '')
                                }, null, 10, _hoisted_165), [
                                  [_vModelText, staff.memoStatus]
                                ]),
                                _createElementVNode("button", {
                                  class: "btn-small",
                                  onClick: ($event: any) => (_unref(saveMemoStatusStaff)(staff, home.value, _unref(toDateKey)(_unref(targetDate)), _unref(bCode)))
                                }, "保存", 8, _hoisted_166)
                              ])
                            ])
                          ], 2))
                        }), 128))
                      ])
                    ])
                  ])
                ]),
                (isMaintDisp.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_167, [
                      _createElementVNode("button", {
                        onClick: _cache[27] || (_cache[27] = 
//@ts-ignore
(...args) => (_unref(onMaintC2Schedule) && _unref(onMaintC2Schedule)(...args)))
                      }, "児童予定の重複削除"),
                      _createElementVNode("button", {
                        onClick: _cache[28] || (_cache[28] = 
//@ts-ignore
(...args) => (_unref(onMaintC3Result) && _unref(onMaintC3Result)(...args)))
                      }, "児童実績の重複削除"),
                      _createElementVNode("button", {
                        onClick: _cache[29] || (_cache[29] = 
//@ts-ignore
(...args) => (_unref(onMaintMStaff) && _unref(onMaintMStaff)(...args)))
                      }, "従事者M修正(NULL許容)"),
                      _createElementVNode("button", {
                        onClick: _cache[30] || (_cache[30] = 
//@ts-ignore
(...args) => (_unref(onMaintMChild) && _unref(onMaintMChild)(...args)))
                      }, "児童M修正(NULL許容)"),
                      _createElementVNode("button", {
                        onClick: _cache[31] || (_cache[31] = 
//@ts-ignore
(...args) => (_unref(checkMaintMStaffBase) && _unref(checkMaintMStaffBase)(...args)))
                      }, "従事者M確認(存在しない拠点)"),
                      _createElementVNode("button", {
                        onClick: _cache[32] || (_cache[32] = 
//@ts-ignore
(...args) => (_unref(onMaintMStaffDailyMemo) && _unref(onMaintMStaffDailyMemo)(...args)))
                      }, "MStaffDailyMemoの重複(SCode, SEdDate)を削除")
                    ]))
                  : (_openBlock(), _createElementBlock("div", {
                      key: 1,
                      class: "square",
                      onContextmenu: _cache[33] || (_cache[33] = _withModifiers(($event: any) => (isMaintDisp.value = true), ["meta","right"]))
                    }, "■", 32))
              ])
            ], 64))
          : (_openBlock(), _createElementBlock("div", _hoisted_168, _toDisplayString(_unref(masterMsg)), 1))
      ])
    ]),
    (_unref(eventDialog).disp)
      ? (_openBlock(), _createElementBlock("div", _hoisted_169, [
          _createElementVNode("div", _hoisted_170, [
            _createElementVNode("h2", null, "行事予定・注意事項の" + _toDisplayString(_unref(eventDialog).type === 1 ? '追加' : '編集'), 1),
            _createElementVNode("div", _hoisted_171, [
              _createElementVNode("dl", null, [
                _hoisted_172,
                _createElementVNode("dd", null, [
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => (_isRef(eventDialogTargetDateFrom) ? (eventDialogTargetDateFrom).value = $event : null)),
                    class: "short",
                    type: "date"
                  }, null, 512), [
                    [_vModelText, _unref(eventDialogTargetDateFrom)]
                  ]),
                  _hoisted_173,
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => (_isRef(eventDialogTargetDateTo) ? (eventDialogTargetDateTo).value = $event : null)),
                    class: "short",
                    type: "date"
                  }, null, 512), [
                    [_vModelText, _unref(eventDialogTargetDateTo)]
                  ])
                ]),
                _hoisted_174,
                _createElementVNode("dd", null, [
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => ((_unref(eventDialog).dEvent.itemName) = $event)),
                    class: _normalizeClass(["short", _unref(toValidClassStr)(_unref(eventDialog).dEvent.itemName)]),
                    type: "text"
                  }, null, 2), [
                    [_vModelText, _unref(eventDialog).dEvent.itemName]
                  ])
                ]),
                _hoisted_175,
                _createElementVNode("dd", null, [
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => ((_unref(eventDialog).dEvent.itemUrl) = $event)),
                    class: _normalizeClass(["full", _unref(toValidClassStr)(_unref(eventDialog).dEvent.itemUrl)]),
                    type: "text"
                  }, null, 2), [
                    [_vModelText, _unref(eventDialog).dEvent.itemUrl]
                  ])
                ]),
                _hoisted_176,
                _createElementVNode("dd", null, [
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event: any) => (_isRef(eventDialogStartDate) ? (eventDialogStartDate).value = $event : null)),
                    class: "short",
                    type: "date"
                  }, null, 512), [
                    [_vModelText, _unref(eventDialogStartDate)]
                  ]),
                  _hoisted_177,
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[39] || (_cache[39] = ($event: any) => (_isRef(eventDialogEndDate) ? (eventDialogEndDate).value = $event : null)),
                    class: "short",
                    type: "date"
                  }, null, 512), [
                    [_vModelText, _unref(eventDialogEndDate)]
                  ])
                ])
              ])
            ]),
            _createElementVNode("ul", _hoisted_178, [
              _createElementVNode("li", null, [
                _createElementVNode("button", {
                  class: "modal-close",
                  onClick: _cache[40] || (_cache[40] = ($event: any) => (_unref(okEventDialog)(home.value, _unref(toDateKey)(_unref(targetDate)), _unref(bCode)))),
                  disabled: !_unref(isValidEventDialog)(home.value)
                }, _toDisplayString(_unref(eventDialog).type === 1 ? '追加' : '保存'), 9, _hoisted_179)
              ]),
              _createElementVNode("li", null, [
                _createElementVNode("button", {
                  class: "modal-close",
                  onClick: _cache[41] || (_cache[41] = ($event: any) => (_unref(cancelEventDialog)(home.value)))
                }, "キャンセル")
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(RepunchDialog, {
      modelValue: repunchCtrl.value,
      "onUpdate:modelValue": _cache[42] || (_cache[42] = ($event: any) => ((repunchCtrl).value = $event)),
      "punch-titles": _unref(initRepunchTitles)('登園', '降園'),
      "name-after": "",
      onOk: _cache[43] || (_cache[43] = async () => okRepunch()),
      "in-out": ['新たな登園打刻', '前回の降園打刻'],
      deadline: _unref(user)?.sRoll === _unref(StaffRoll).admin ? undefined : _unref(deadlineSche)
    }, null, 8, ["modelValue", "punch-titles", "deadline"])
  ], 64))
}
}

})